import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon65: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20

  const originalHeight = 21

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 21" width={width} height={height} {...props}>
      <G clipPath="url(#clip0_20739_2738)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.992 0L10.407 0.564987C11.085 1.48899 11.581 2.53499 11.896 3.70099C12.236 4.96199 11.745 6.117 10.501 7.11L10.5 7.922L10.717 7.924C13.803 7.966 16.602 8.28299 19.115 8.87399C19.312 8.92099 19.459 9.081 19.493 9.276L19.5 9.36099V19.361C19.776 19.361 20 19.585 20 19.861C20 20.106 19.823 20.311 19.59 20.353L19.5 20.361H0.5C0.224 20.361 0 20.137 0 19.861C0 19.615 0.177004 19.411 0.410004 19.369L0.5 19.361V11.365C0.5 11.357 0.5 11.348 0.5 11.34V9.36099C0.5 9.12899 0.659994 8.92699 0.884995 8.87399C3.45699 8.26899 6.328 7.952 9.5 7.922V7.10199C8.244 6.08199 7.754 4.92699 8.114 3.69099C8.443 2.56399 8.936 1.52499 9.593 0.575989L9.992 0ZM6.991 12.664L6.96899 12.709C6.27099 14.05 5.344 14.785 4.185 14.855L4 14.861C3.003 14.861 2.17 14.386 1.5 13.472V19.361H18.5L18.501 13.512C17.843 14.4 17.009 14.861 16 14.861C14.786 14.861 13.826 14.194 13.121 12.921L12.998 12.684L12.989 12.704C12.307 14.048 11.373 14.785 10.189 14.855L10 14.861C8.793 14.861 7.835 14.195 7.127 12.922L6.991 12.664ZM10 8.91899C6.939 8.91899 4.166 9.18699 1.683 9.71999L1.5 9.75999V11.274L1.56 11.439C2.184 13.092 2.998 13.861 4 13.861C5.05 13.861 5.894 13.017 6.528 11.196C6.685 10.745 7.32501 10.75 7.47501 11.204C8.07601 13.021 8.916 13.861 10 13.861C11.084 13.861 11.924 13.021 12.525 11.204C12.677 10.746 13.326 10.747 13.475 11.206C14.068 13.022 14.907 13.861 16 13.861C17.078 13.861 17.909 13.044 18.501 11.278L18.5 9.75999L18.317 9.71999C16.025 9.22799 13.486 8.962 10.701 8.924L10 8.91899ZM10.012 1.778L9.808 2.14699C9.506 2.72299 9.26101 3.32999 9.07401 3.97099C8.901 4.56399 9.032 5.137 9.5 5.711V4.86099C9.5 4.58499 9.724 4.36099 10 4.36099C10.245 4.36099 10.45 4.538 10.492 4.771L10.5 4.86099L10.501 5.726C10.925 5.207 11.072 4.67599 10.966 4.11699L10.93 3.961C10.742 3.263 10.482 2.615 10.151 2.017L10.012 1.778Z"
          fill="#404040"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_20739_2738">
          <Rect width={20} height={20.361} fill="white" />
        </ClipPath>
      </Defs>
    </Icon>
  )
}
